import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import classNames from 'classnames';
import FormField from './FormField';
import FormGroup from './FormGroup';

export default class TextArea extends FormField {
  get pattern() {
    return /([^\s])/;
  }

  render() {
    const { error, checked } = this.state;
    const textareaProps = _.omit(this.props, 'onValidate');
    return (
      <FormGroup {...this.props}>
        <textarea
          {...textareaProps}
          className={classNames('form-group-textarea', { error, checked })}
          onChange={this.onChange}
          onBlur={this.onBlur}
          value={this.state.value}
        />
      </FormGroup>
    );
  }
}

TextArea.propTypes = {
  ...FormField.propTypes,
  id: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  type: PropTypes.string,
};
